/* eslint-disable @typescript-eslint/no-explicit-any */
import { v4 } from 'uuid';

import { blueprintData7 } from '../defaults';
import { deepCopy } from '../../helpers';
import { updateKitchens } from './update.7/update-kitchens';
import { BlueprintData6, BlueprintData7 } from '../types';

export const u7 = (blueprint: BlueprintData6): BlueprintData7 | null => {
	console.log('schema-update:process-update:7:started');

	try {
		const bpd: BlueprintData7 = {
			...deepCopy(blueprintData7),
			id: v4(),
			schemaVersion: 7,
			email: blueprint.email,
			submissionDate: blueprint.date,
			submissionId: blueprint.date,
			thumbnail: blueprint.image,
			metadata: {
				estimateNumber: blueprint.estimateNumber,
				invoiceNumber: blueprint.invoiceNumber,
				workorderNumber: blueprint.workorderNumber,
				paymentStatus: 'Not Paid'
			},
			kitchens: updateKitchens(blueprint)
		};

		console.log('schema-update:process-update:7:completed', bpd);
		return bpd;
	} catch (err) {
		console.error(err);
	}

	console.log('schema-update:process-update:7:failed');
	return null;
};
